"use client";
import { Dialog } from "@headlessui/react";
import { motion } from "framer-motion";
import { useState } from "react";

import FormFreeTrial from "./form-free-trial";

const ButtonFreeTrial = () => {
  const [isOpen, setIsOpen] = useState(false);

  const openModal = () => setIsOpen(true);
  const closeModal = () => setIsOpen(false);

  const modalFadeVariants = {
    hidden: {
      opacity: 0,
    },
    visible: {
      opacity: 1,
      transition: {
        duration: 0.2,
      },
    },
  };

  return (
    <>
      <button
        onClick={openModal}
        className='btn text-base text-slate-900 bg-gradient-to-r from-white/80 via-white to-white/80 hover:bg-white transition duration-150 ease-in-out group'
      >
        Teste Grátis{" "}
        <span className='tracking-normal text-purple-500 group-hover:translate-x-0.5 transition-transform duration-150 ease-in-out ml-1'>
          ➤
        </span>
      </button>

      <Dialog open={isOpen} onClose={closeModal} className='fixed inset-0 overflow-y-auto z-30'>
        <div className='min-h-screen px-4 text-center'>
          <Dialog.Overlay className='fixed inset-0 bg-black opacity-30' />

          <span className='inline-block h-screen align-middle' aria-hidden='true'>
            &#8203;
          </span>

          <motion.div
            initial='hidden'
            animate={isOpen ? "visible" : "hidden"}
            variants={modalFadeVariants}
            className='inline-block w-full max-w-md p-6 my-8 overflow-hidden text-left align-middle transition-all transform bg-white shadow-xl rounded-2xl'
          >
            <FormFreeTrial />
            <div className='mt-4 flex justify-center'>
              <button
                type='button'
                className='btn text-white bg-red-500 hover:bg-red-600 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm '
                onClick={closeModal}
              >
                Fechar
              </button>
            </div>
          </motion.div>
        </div>
      </Dialog>
    </>
  );
};

export default ButtonFreeTrial;
